<template>
  <el-form
    ref="form"
    label-position="top"
    style="width: 100%;"
  >
    <el-form-item label="반영 요일 선택">
      <DayOfWeekVisibilitySelect
        :course-dates="courseDates"
        @change="onChangeDayOfWeekVisible"
      />
    </el-form-item>

    <el-form-item label="타이틀 수정 또는 로고 적용">
      <el-input
        v-model="title"/>

      <el-upload
        class="logo-image-upload"
        action=""
        :on-remove="handleRemove"
        :on-exceed="handleExceed"
        :on-change="handleFileUpload"
        :limit="1"
        :auto-upload="false"
        :file-list="fileList"
      >
        <el-button class="gray">
          로고 이미지 업로드
        </el-button>
      </el-upload>

    </el-form-item>

    <el-form-item label="배경 색상 변경">
      <el-color-picker
        :value="backgroundColor"
        @change="onChangeBackgroundColor"
      ></el-color-picker>
    </el-form-item>

    <el-form-item label="주간 기간 표시">
      <el-switch
        :value="showPeriod"
        @change="onChangeShowPeriod"
      />
    </el-form-item>

    <el-form-item label="좌측 시간 표시">
      <el-switch
        :value="showFirstColumnTime"
        @change="onChangeShowFirstColumnTime"
      />
    </el-form-item>

    <el-form-item label="수업 시간 표시">
      <el-switch
        :value="showCourseTime"
        @change="onChangeShowCourseTime"
      />
    </el-form-item>

    <el-form-item label="수업 강사 표시">
      <el-switch
        :value="showInstructors"
        @change="onChangeShowInstructors"
      />
    </el-form-item>

    <el-form-item label="미반영 수업 선택">
      <ParentCourseSelectBox
        :value="invisibleParentCourses"
        @change="onChangeInvisibleParentCourses"
        placeholder="수업을 모두 선택해주세요."
        :option-groups="parentCourseCategories"
      />
    </el-form-item>

    <el-form-item label="수업명 글자 크기">
      <div class="el-input-group__unit">
        <el-input-number
          :value="fontSize"
          @change="onChangeFontSize"
          controls-position="right"
          :min="50"
          :max="200"
          :step="10"
        />
        <div class="input-unit">
          %
        </div>
      </div>
    </el-form-item>
    <el-form-item label="강사/시간 글자 크기">
      <div class="el-input-group__unit">
        <el-input-number
          :value="subFontSize"
          @change="onChangeSubFontSize"
          controls-position="right"
          :min="50"
          :max="200"
          :step="10"
        />
        <div class="input-unit">
          %
        </div>
      </div>
    </el-form-item>
    <el-form-item label="브레이크 타임 설정">
      <BreakTimeEditor
        :value="breakTimes"
        @change="onChangeBreakTimes"
        :course-start-end-times="courseStartEndTimes"/>
    </el-form-item>
  </el-form>
</template>

<script>
  import DayOfWeekVisibilitySelect from "./DayOfWeekVisibilitySelect";
  import ParentCourseSelectBox from "../MemberManagePage/ParentCourseSelectBox";
  import { computedGetters } from "../../utils/vuex-helper";
  import BreakTimeEditor from "./BreakTimeEditor";

  export default {
    name: "TimeTableDesktopOptionForm",
    components: {
      BreakTimeEditor, ParentCourseSelectBox, DayOfWeekVisibilitySelect
    },
    props: {
      parentCourseCategories: {},
      courseDates: {},
      courseStartEndTimes: {},
      fileList: []
    },
    computed: {
      ...computedGetters([
        "centerAccount"
      ]),
      ...computedGetters([
        "dayOfWeekVisible",
        "backgroundColor",
        "showPeriod",
        "showFirstColumnTime",
        "showCourseTime",
        "showInstructors",
        "invisibleParentCourses",
        "fontSize",
        "subFontSize",
        "breakTimes",
      ], "timeTable"),
      title: {
        get () {
          return this.$store.getters['timeTable/getTitle']
        },
        set (value) {
          this.$store.commit('timeTable/setTitle', value)
        }
      }
    },
    methods: {
      onChangeDayOfWeekVisible(value) {
        this.$store.commit("timeTable/setDayOfWeekVisible", value)
      },
      onChangeBackgroundColor(value) {
        this.$store.commit("timeTable/setBackgroundColor", value)
      },
      onChangeShowPeriod(value) {
        this.$store.commit("timeTable/setShowPeriod", value)
      },
      onChangeShowFirstColumnTime(value) {
        this.$store.commit("timeTable/setShowFirstColumnTime", value)
      },
      onChangeShowCourseTime(value) {
        this.$store.commit("timeTable/setShowCourseTime", value)
      },
      onChangeShowInstructors(value) {
        this.$store.commit("timeTable/setShowInstructors", value)
      },
      onChangeInvisibleParentCourses(value) {
        this.$store.commit("timeTable/setInvisibleParentCourses", value)
      },
      onChangeFontSize(value) {
        this.$store.commit("timeTable/setFontSize", value)
      },
      onChangeSubFontSize(value) {
        this.$store.commit("timeTable/setSubFontSize", value)
      },
      onChangeBreakTimes(value) {
        this.$store.commit("timeTable/setBreakTimes", value)
      },
      handleRemove(file, fileList) {
        this.fileList = [];
        this.$emit('onUpdateLogoImage', null)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`하나의 이미지만 올릴 수 있습니다.`);
      },
      handleFileUpload(file, fileList) {
        let reader = new FileReader();
        reader.onload = e => {
          this.$emit('onUpdateLogoImage', e.target.result)
        };

        reader.readAsDataURL(file.raw);
      },
    }
  }
</script>

<style scoped>

</style>